import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    surface: {
        ...StyleSheet.absoluteFill,
        overflow: "hidden"
    },
    center: {
        ...StyleSheet.absoluteFill,
        justifyContent: "center",
        alignItems: "center"
    },
    fill: {
        ...StyleSheet.absoluteFill
    },
    overlay: {
        ...StyleSheet.absoluteFill
    },
    container: {
        flexShrink: 1,
        minHeight: 0,
        flexGrow: 1,
        minWidth: 0,
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    }
});

export const useStyles = ({
    isFocusVisible,
    shapeConfigs,
    radiuses,
    borders,
    colors
}: {
    colors: NCoreUIKit.ActivePalette["colors"];
    shapeConfigs: NCoreUIKit.ShapeConfigs;
    radiuses: NCoreUIKit.Radiuses;
    borders: NCoreUIKit.Borders;
    isFocusVisible: boolean;
}) => {
    const styles = {
        surface: {
            backgroundColor: colors.content.container.subtle,
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        scrim: {
            backgroundColor: colors.system.scrim
        } as Mutable<ViewStyle>,
        container: {
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        overlay: {
            ...getCornerStyle({
                radius: radiuses.xs,
                shapeConfigs
            })
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.overlay, getFocusRingStyle({
        isFocusVisible,
        isInset: true,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
